module.exports = __webpack_public_path__ + "img/pin-vertido.5fec8003.png";